import { memo, createElement, FC, CSSProperties, ReactNode } from 'react';

import { classNames } from 'shared/utils/class-names';
import classes from './styles.module.scss';

export type TextTypes =
  | 'm-section'
  | 'm-section-bold'
  | 'm-titles'
  | 'm-subtitles'
  | 'm-titles-bold'
  | 'm-metrics'
  | 'm-heading'
  | 'm-subheading'
  | 'm-subheading-light'
  | 'm-heading-l'
  | 'm-body'
  | 'm-body-emphasized'
  | 'm-caption'
  | 'm-caption-emphasized'
  | 'sf-heading'
  | 'sf-subheading'
  | 'sf-subheading-medium'
  | 'sf-subheading-light'
  | 'sf-body'
  | 'sf-body-medium'
  | 'sf-body-emphasized'
  | 'sf-base'
  | 'sf-caption'
  | 'sf-caption-emphasized';

export type TextColors =
  | 'base-white'
  | 'default'
  | 'grey'
  | 'grey-primary'
  | 'grey-second'
  | 'grey-fifth'
  | 'grey-seventh'
  | 'grey-eighth'
  | 'grey-disabled'
  | 'info'
  | 'info-second'
  | 'info-third'
  | 'success'
  | 'success-second'
  | 'success-third'
  | 'attention'
  | 'critical'
  | 'critical-second'
  | 'critical-third'
  | 'blue-ultra-light'
  | 'blue-light'
  | 'blue-mid'
  | 'blue-dark'
  | 'blue-ultra-dark'
  | 'ant-yellow-100'
  | 'grey-thirteenth'
  | 'yellow-600'
  | 'deep-blue';

export interface IText {
  type?: TextTypes;
  color?: TextColors;
  upperCase?: boolean;
  component?: string;
  style?: CSSProperties;
  className?: string;
  onClick?: (e: any | undefined) => void;
  children: ReactNode;
  [key: string]: any;
}

export const Text: FC<IText> = memo(
  ({
    type = 'm-body',
    component = 'p',
    children,
    style,
    className,
    upperCase = false,
    color = 'grey-primary',
    ...otherProps
  }) => {
    const props = {
      className: classNames(
        classes[type],
        classes[color],
        { [classes.uppercase]: upperCase },
        className
      ),
      style: { style },
      ...otherProps
    };

    return createElement(component, props, children);
  }
);

Text.displayName = 'Text';
